import { render, staticRenderFns } from "./CallView.vue?vue&type=template&id=97ba3b10&scoped=true&"
import script from "./CallView.vue?vue&type=script&lang=js&"
export * from "./CallView.vue?vue&type=script&lang=js&"
import style0 from "./CallView.vue?vue&type=style&index=0&id=97ba3b10&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97ba3b10",
  null
  
)

export default component.exports